import styled from 'styled-components'

export const MapShell = styled.div`
  width: 100%;
  height: calc(100vh - 16rem);
  min-height: 30rem;
  border-radius: 1rem;
  overflow: hidden;
  background: #141312;
  position: sticky;
  top: 0;
  @media (max-width: 1100px) {
    position: static;
    height: 30rem;
  }
`

export const MapLoading = styled.div`
  width: 100%;
  height: calc(100vh - 16rem);
  min-height: 30rem;
  border-radius: 1rem;
  background: ${(props) => props.theme.colorSurface1};
  border: 1px solid ${(props) => props.theme.colorDividerDefault};
`
